var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-justify"},[_c('form-upload-v2-ovv-location-critical-index',{attrs:{"activity":_vm.activity,"title":"LOCALIZACIONES CRÍTICAS DEL ORGANISMO","subtitle":_vm.$store.getters.getTag('3.2.S'),"footer":_vm.$store.getters.getTag('3.2.F')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }